// SEARCH input class — [공통] 00_입력검증표준 v1.2 §3 / §4.2.
//
//   길이   1~50자
//   문자   기본 문자 + 일반 특수문자 허용, 이모지 불허 (§4.2 — 이모지 전 클래스 불허)
//   줄바꿈 불가 — 붙여넣기 시 공백으로 치환 (§4.2 마지막 항목)
//
// SHCT-713 — 건강백과 제목 검색만 이 규칙이 통째로 빠져 있었다 (maxLength = -1,
// 이모지 무검증). 같은 표준을 쓰는 목록 검색창이 화면마다 있으므로 규칙을 여기에
// 한 벌만 두고 각 화면이 가져다 쓴다.
//
// Pure helpers — no i18n, no DOM — so the form and its unit tests share them.

import { hasEmoji } from './emoji';

// §4.2's emoji ban is app-wide, not a SEARCH rule — it lives in `./emoji` and is
// re-exported here so existing `from '@/shared/utils/search-input'` imports keep
// working (SHCT-853~860 consolidated the three duplicated copies).
export { hasEmoji };

/** [공통] 00 §3 — SEARCH class hard cap. */
export const SEARCH_MAX = 50;

/**
 * Normalizes what a single-line search box accepts: newlines (only reachable by
 * paste) collapse to a space per §4.2, and the value is hard-capped at
 * {@link SEARCH_MAX}. Emoji are deliberately NOT stripped here — §4.2 requires
 * an inline error, so the typed value stays visible and {@link hasEmoji} drives
 * the message.
 */
export function normalizeSearchInput(raw: string): string {
  return raw.replace(/[\r\n]+/g, ' ').slice(0, SEARCH_MAX);
}

/** True when the value may be sent to the server as a search term. */
export function isSearchInputValid(value: string): boolean {
  return value.length <= SEARCH_MAX && !hasEmoji(value);
}
